/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import ajaxBank from "../../../util/remote/ajaxBank";
import AppContainer from "../../../Components/Structure/AppContainer";
import TermlyFeesList from "../../../Components/Statistics/TermlyFees/TermlyFeesList";
import TermlyFeeInvoicesCount from "../../../Components/Statistics/TermlyFees/TermlyFeeInvoicesCount";
import TermlyFeesPerSchool from "../../../Components/Statistics/TermlyFees/TermlyFeesPerSchool";

function TermlyFeesPage() {
    const [loading2, setLoading2] = useState(false);
    const [termlyFeesPerSchool, setTermlyFeesPerSchool] = useState(false);
    const [termlyFeeInvoiceCounts, setTermlyFeeInvoiceCounts] = useState(false);

    const [cumulativeTermlyFees, setCumulativeTermlyFees] = useState(false);
    const [loadingPage, setLoadingPage] = useState(true);

    useEffect(() => {
  const fetchAll = async () => {
    setLoadingPage(true);
    await Promise.all([
      getTotalTermlyFees(),
      getTermlyFeeInvoiceCounts(),
      getTermlyFeesPerSchool()
    ]);
    setLoadingPage(false);
  };

  fetchAll();
}, []);

    const getTotalTermlyFees = async () => {
        const server_response = await ajaxBank.fetchTotalTermlyFeesPaid();
        if (server_response.status === "OK") {
          setCumulativeTermlyFees(server_response.details);
        } else {
          setCumulativeTermlyFees(false);
        }
    };

    const getTermlyFeeInvoiceCounts = async () => {
        const server_response = await ajaxBank.fetchTermlyFeeInvoiceCount();
        if (server_response.status === "OK") {
          setTermlyFeeInvoiceCounts(server_response.details);
        } else {
          setTermlyFeeInvoiceCounts("404");
        }
    };

    const getTermlyFeesPerSchool = async () => {
      setLoading2(true);
        const server_response = await ajaxBank.fetchTermlyFeeStatsPerSchool();
         
        setLoading2(false);
        if (server_response.status === "OK") {
          setTermlyFeesPerSchool(server_response.details);
        } else {
          setTermlyFeesPerSchool("404");
        }
    };


  return (
    <AppContainer title="Termly Fees">
      <Toaster position="top-center" reverseOrder={false} />
      {loadingPage ? (
                          // Full page skeleton loader
                          <div style={{ padding: 40 }}>
                            <Skeleton height={40} width={300} style={{ marginBottom: 20 }} />
                            <Skeleton height={200} style={{ marginBottom: 20 }} />
                            <Skeleton count={5} height={30} style={{ marginBottom: 10 }} />
                          </div>
                        ) : (
      <div className="row">
        <div className="col-lg-5">
          <div className="row">
          <TermlyFeeInvoicesCount termlyFeeCount={termlyFeeInvoiceCounts}/>
          <TermlyFeesPerSchool schoolTermlyFees={termlyFeesPerSchool} loading={loading2}/>
           
          </div> 
        </div>
        
        <div className="col-lg-7">
          <div className="row">
            <div class="col-lg-12">
                <div class="card custom-card" style={{ paddingBottom: "10px" }}>
                    <div className="card-body map-card gradient-my-blue">
                        <div class="item-title mb-2" style={{ color: "white" }}>
                            <b>OVERALL</b>
                        </div>
                        <div class="row">
                        
                            <div class="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                <div class="text-center">
                                    <h2 class="mb-1 number-font" style={{ color: "white" }}>
                                        <span class="counter">
                                            UGX. {cumulativeTermlyFees? cumulativeTermlyFees.total_c:"..."}
                                        </span>
                                    </h2>
                                    <p class="mb-0 text-light"> Cumulative Termly Fees</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <TermlyFeesList/>
            

          </div>
        </div>

        
      </div>)}
    </AppContainer>
  );
}

export default TermlyFeesPage;
